import React from "react";

const TextLink = ({ href, children, ...props }) => {
    const {className, text} = props;
    const textClass = `text-[16px] hover:underline hover:text-[#2374fd] ${className || ''}`;
    return (
        <a href={href} className={textClass}>
            { text || '' }
            {children}
        </a>
    );
};

export default TextLink;
